import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapState } from 'vuex';
export default {
  methods: {
    toMissionModule: function toMissionModule() {
      var top = document.querySelector('#mission').offsetTop; // 兼容 二者只会有一个起作用

      document.documentElement.scrollTop = top;
      document.body.scrollTop = top;
    },
    showRules: function showRules() {
      this.$emit('showRule');
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('bump', ['myEggInfo'])), {}, {
    panelFir: function panelFir() {
      return this.setting.面板一;
    },
    panelSec: function panelSec() {
      return this.setting.面板二;
    },
    panelFirBtn: function panelFirBtn() {
      var eggInfo = this.myEggInfo;

      if (eggInfo) {
        if (eggInfo.egg_type === 1) {
          // 今日蛋可升级
          return this.setting.面板一.今日已镀金;
        } else if (eggInfo.is_yesrecved) {
          return this.setting.面板一.今日可镀金;
        }
      } // 默认返回明天可镀金


      return this.setting.面板一.明天可镀金;
    }
  }),
  settingKey: '策略模块',
  setting: {
    面板一: {
      type: 'object',
      properties: {
        蛋皮肤: 'https://puui.qpic.cn/vupload/0/20190619_1560935540781_vumhz5p2mpf.png/0',
        主标题: '镀金彩蛋',
        副标题: '连续登录2天，福利彩蛋变身镀金彩蛋，彩蛋额外+2',
        角标: '最高18888元',
        明天可镀金: 'https://puui.qpic.cn/vupload/0/20190620_1561001106834_l6obfz0m4vk.png/0',
        今日可镀金: 'https://puui.qpic.cn/vupload/0/20190705_1562930387056_oq3bazkgks.png/0',
        今日已镀金: 'https://puui.qpic.cn/vupload/0/20190705_1562930387063_nx4ugoke5yk.png/0',
        奖品列表: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              图片: 'https://puui.qpic.cn/vupload/0/20190617_1560770941770_g7mokm3hsu5.png/0',
              名字: 'iPhone X'
            }
          }
        }
      }
    },
    面板二: {
      type: 'object',
      properties: {
        蛋皮肤: '//puui.qpic.cn/vupload/0/1561001224680_wywdkkzf04n/0',
        主标题: '福利彩蛋',
        副标题: '连续登录2天，福利彩蛋变身镀金彩蛋，彩蛋额外+2',
        角标: '最高888元',
        右侧默认按钮: 'https://puui.qpic.cn/vupload/0/20190620_1561001137215_91241mfxplb.png/0',
        奖品列表: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              图片: 'https://puui.qpic.cn/vupload/0/20190617_1560770941770_g7mokm3hsu5.png/0',
              名字: 'iPhone X'
            }
          }
        }
      }
    },
    查看详情规则按钮: {
      type: 'image',
      default: 'https://puui.qpic.cn/vupload/0/20190627_1561636323085_ng5vu5ms7j.png/0'
    }
  }
};